import { createRouter, createWebHashHistory, type RouteRecordRaw } from 'vue-router'
import Login from '@/views/login/LoginPage.vue'
import NotFound from '@/views/errors/NotFountPage.vue'
import Layout from '@/layout/MyLayout.vue'
import CustomerLayout from '@/layout/CustomerLayout.vue'
import WebsiteLayout from '@/layout/WebsiteLayout.vue'

const routes: Array<RouteRecordRaw> = [
  // 官网路由
  {
    path: '/',
    component: WebsiteLayout,
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('@/views/home/HomePage.vue'),
        meta: { title: '鼎骁科技|官网|一栈式电子开发平台 电子产品ODM OEM' }
      },
      {
        path: '/xiadanxuzhi',
        name: 'Xiadanxuzhi',
        component: () => import('@/views/website/XiadanxuzhiPage.vue'),
        meta: { title: '鼎骁科技|下单须知' }
      },
      {
        path: '/xinwenzixun',
        name: 'Xinwenzixun',
        component: () => import('@/views/website/XinwenzixunPage.vue'),
        meta: { title: '鼎骁科技|新闻资讯' }
      },
      {
        path: '/fuwuzhichi',
        name: 'Fuwuzhichi',
        component: () => import('@/views/website/FuwuzhichiPage.vue'),
        meta: { title: '鼎骁科技|服务支持' }
      },
      {
        path: '/guanyuwomen',
        name: 'Guanyuwomen',
        component: () => import('@/views/website/GuanyuwomenPage.vue'),
        meta: { title: '鼎骁科技|关于我们' }
      }
    ]
  },
  // 后台管理路由（管理员）
  {
    path: '/admin',
    redirect: '/admin/dashboard',
    name: 'admin',
    component: Layout,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/admin/DashboardPage.vue'),
        meta: { title: '后台首页', requiresAuth: true }
      },
      {
        path: 'tools/icname',
        name: 'ICNameTool',
        component: () => import('@/views/admin/tools/ICNameToolPage.vue'),
        meta: { title: 'IC命名工具', requiresAuth: true }
      },
      {
        path: 'tools/claude-chat',
        name: 'ClaudeChat',
        component: () => import('@/views/admin/tools/ClaudeChatPage.vue'),
        meta: { title: 'Claude Code 通信', requiresAuth: true }
      },
      {
        path: 'tools/claude-terminal',
        name: 'ClaudeTerminal',
        component: () => import('@/views/admin/tools/ClaudeTerminalPage.vue'),
        meta: { title: 'Claude Code 终端', requiresAuth: true }
      },
      {
        path: 'tools/mqtt-test',
        name: 'MqttTest',
        component: () => import('@/views/admin/tools/MqttTestPage.vue'),
        meta: { title: 'MQTT通讯测试', requiresAuth: true }
      },
      {
        path: 'tools/mqtt-upgrade',
        name: 'MqttUpgrade',
        component: () => import('@/views/admin/tools/MqttUpgradePage.vue'),
        meta: { title: 'MQTT升级工具', requiresAuth: true }
      },
      {
        path: 'tools/serial-debug',
        name: 'SerialDebug',
        component: () => import('@/views/admin/tools/SerialDebugPage.vue'),
        meta: { title: '串口调试工具', requiresAuth: true }
      },
      {
        path: 'tools/print-designer',
        name: 'PrintDesigner',
        component: () => import('@/views/admin/tools/PrintDesignerPage.vue'),
        meta: { title: '打印设计器', requiresAuth: true }
      },
      {
        path: 'tools/delivery-order',
        name: 'DeliveryOrder',
        component: () => import('@/views/admin/tools/DeliveryOrderPage.vue'),
        meta: { title: '送货单管理', requiresAuth: true }
      }
    ]
  },
  // 客户中心路由（客户登录后使用）
  {
    path: '/customer',
    redirect: '/customer/home',
    name: 'customer',
    component: CustomerLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'home',
        name: 'CustomerHome',
        component: () => import('@/views/customer/HomeCenterPage.vue'),
        meta: { title: '客户中心首页', requiresAuth: true }
      },
      {
        path: 'project/create',
        name: 'CreateProject',
        component: () => import('@/views/customer/project/CreateProjectPage.vue'),
        meta: { title: '新建项目', requiresAuth: true }
      },
      {
        path: 'project/active',
        name: 'ActiveProjects',
        component: () => import('@/views/customer/project/ActiveProjectsPage.vue'),
        meta: { title: '进行中的项目', requiresAuth: true }
      },
      {
        path: 'project/completed',
        name: 'CompletedProjects',
        component: () => import('@/views/customer/project/CompletedProjectsPage.vue'),
        meta: { title: '已完工项目', requiresAuth: true }
      },
      {
        path: 'production/order',
        name: 'ProductionOrder',
        component: () => import('@/views/customer/production/ProductionOrderPage.vue'),
        meta: { title: '生产订单', requiresAuth: true }
      },
      {
        path: 'production/progress',
        name: 'ProductionProgress',
        component: () => import('@/views/customer/production/ProductionProgressPage.vue'),
        meta: { title: '生产进度', requiresAuth: true }
      },
      {
        path: 'usercenter/account',
        name: 'AccountInfo',
        component: () => import('@/views/customer/user/AccountInfoPage.vue'),
        meta: { title: '账号信息', requiresAuth: true }
      },
      {
        path: 'usercenter/file',
        name: 'FileManage',
        component: () => import('@/views/customer/user/FileManagePage.vue'),
        meta: { title: '文件管理', requiresAuth: true }
      },
      {
        path: 'usercenter/notification',
        name: 'Notification',
        component: () => import('@/views/customer/user/NotificationPage.vue'),
        meta: { title: '消息通知', requiresAuth: true }
      },
      {
        path: 'usercenter/security',
        name: 'SecurityCenter',
        component: () => import('@/views/customer/user/SecurityCenterPage.vue'),
        meta: { title: '安全中心', requiresAuth: true }
      },
      {
        path: 'usercenter/address',
        name: 'AddressManage',
        component: () => import('@/views/customer/user/AddressManagePage.vue'),
        meta: { title: '地址管理', requiresAuth: true }
      },
      {
        path: 'usercenter/qualification',
        name: 'Qualification',
        component: () => import('@/views/customer/user/QualificationPage.vue'),
        meta: { title: '资质信息', requiresAuth: true }
      },
      {
        path: 'tools/icname',
        name: 'CustomerICNameTool',
        component: () => import('@/views/admin/tools/ICNameToolPage.vue'),
        meta: { title: 'IC命名工具', requiresAuth: true }
      },
      {
        path: 'tools/mqtt-test',
        name: 'CustomerMqttTest',
        component: () => import('@/views/admin/tools/MqttTestPage.vue'),
        meta: { title: 'MQTT通讯测试', requiresAuth: true }
      },
      {
        path: 'tools/mqtt-upgrade',
        name: 'CustomerMqttUpgrade',
        component: () => import('@/views/admin/tools/MqttUpgradePage.vue'),
        meta: { title: 'MQTT升级工具', requiresAuth: true }
      },
      {
        path: 'tools/serial-debug',
        name: 'CustomerSerialDebug',
        component: () => import('@/views/admin/tools/SerialDebugPage.vue'),
        meta: { title: '串口调试工具', requiresAuth: true }
      },
      {
        path: 'tools/print-designer',
        name: 'CustomerPrintDesigner',
        component: () => import('@/views/admin/tools/PrintDesignerPage.vue'),
        meta: { title: '打印设计器', requiresAuth: true }
      },
      {
        path: 'tools/delivery-order',
        name: 'CustomerDeliveryOrder',
        component: () => import('@/views/admin/tools/DeliveryOrderPage.vue'),
        meta: { title: '送货单管理', requiresAuth: true }
      }
    ]
  },
  // 登录
  {
    path: '/login',
    component: Login,
    meta: { title: '登录' }
  },
  // 404
  {
    path: '/:pathMatch(.*)*',
    component: NotFound,
    name: 'NotFound'
  }
]

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: routes
})

export default router
